const Utils = require('core-helpers/utils.js');
const SentryService = require('exceptions/sentry-service.js');

const ExceptionService = (function(root, doc, undefined) {

    const consoleElement = Utils.getById('console-output');

    /**
     * Write down into a textarea all the logs that happened
     * on the page. This is for QA purpose.
     * @param {String} value
     */
    const setHTMLtoAppConsole = (value) => {
        if (consoleElement) {
            consoleElement.value =  consoleElement.value + JSON.stringify(value) + '\n\n';
        }
    };

    /**
     * Throws an error and/or warns in the console
     * Also optionally sends to Sentry (enabled by default for errors)
     *
     * Can be used as such:
     *
     * ExceptionService.handle('error', {
     *     filename: 'something.component.js',
     *     message: 'myFunction() - Something went wrong',
     *     data: {ERROR_OBJECT},
     *     sentry: false
     * });
     *
     * @param  {String} type - 'warning' or 'error'
     * @param  {Object} parameters
     * @param  {String} parameters.filename
     * @param  {String} parameters.message
     * @param  {Object} parameters.data - optional
     * @param  {Boolean} parameters.sendToSentry - optional
     *
     */
    const handle = (type = 'warning', {
        filename = 'Filename unknown',
        message = 'An exception has occurred.',
        data = {},
        sendToSentry = Boolean(type === 'error')
    } = {}) => {
        const log = `[File: ${filename}] ${message}`;
        if (sendToSentry) {
            SentryService.captureException(new Error(log), data);
        }
        Utils.log(filename, message, data);
        setHTMLtoAppConsole(log);
    };

    return {
        handle
    };

})(window, document);


module.exports = ExceptionService;
